import { motion } from "framer-motion";
import { ease } from "../../lib/scroll";

export const Reveal = ({ children, delay = 0, className, y = 40 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.9, ease, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ n, children }) => (
  <div className="mb-5 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-cyanx">
    <span className="text-volt">{n}</span>
    <span className="h-px w-8 bg-white/20" />
    {children}
  </div>
);
